import template from './deeplink-mobile.component.html';
import '../deeplink.service';

angular
    .module('Toke')
    .component('appDeeplinkMobile', {
        template,
        bindings: {
            data: '<',
            state: '<'
        },
        controller: DeeplinkMobileController
    });

DeeplinkMobileController.$inject = ['deeplinkService'];

function DeeplinkMobileController(deeplinkService) {

    const vm = this;

    vm.redirectToChannel = redirectToChannel;

    function redirectToChannel(channelId) {
        deeplinkService.redirectToChannel(
            channelId,
            vm.state.params,
            vm.data.config
        );
    }
}